"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLayout = exports.Layout = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var NavItem_1 = require("../../nav/NavItem");
function Layout(_a) {
    var children = _a.children, header = _a.header, body = _a.body, footer = _a.footer, components = tslib_1.__rest(_a, ["children", "header", "body", "footer"]);
    var HC = components.HeaderComponent;
    var BC = components.BodyComponent;
    var FC = components.FooterComponent;
    var layoutContent = (react_1.default.createElement(react_1.default.Fragment, null,
        (body || children) && react_1.default.createElement(BC, tslib_1.__assign({}, (body !== null && body !== void 0 ? body : {}), { children: children })),
        footer && react_1.default.createElement(FC, tslib_1.__assign({}, footer))));
    if (!header) {
        return layoutContent;
    }
    var contextProvider = NavItem_1.createNavItemContextProvider(header);
    var HeaderContextProvider = contextProvider.NavItemContextProvider, HeaderContextConsumer = contextProvider.NavItemContextConsumer;
    return (react_1.default.createElement(HeaderContextProvider, tslib_1.__assign({}, header),
        react_1.default.createElement(HeaderContextConsumer, null, function (_a) {
            var setNavItems = _a.setNavItems, headerProps = tslib_1.__rest(_a, ["setNavItems"]);
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(HC, tslib_1.__assign({}, headerProps)),
                " ",
                layoutContent));
        })));
}
exports.Layout = Layout;
function useLayout(_a) {
    var HeaderComponent = _a.HeaderComponent, BodyComponent = _a.BodyComponent, FooterComponent = _a.FooterComponent, children = _a.children, props = tslib_1.__rest(_a, ["HeaderComponent", "BodyComponent", "FooterComponent", "children"]);
    return (react_1.default.createElement(Layout, tslib_1.__assign({}, { HeaderComponent: HeaderComponent, BodyComponent: BodyComponent, FooterComponent: FooterComponent }, props), children));
}
exports.useLayout = useLayout;
//# sourceMappingURL=Layout.js.map